import React, { Component } from 'react';
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Row, Col, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Form, FormGroup, Label } from 'reactstrap';
import { Utils } from '../../../services';
import TranslatableField from '../../../components/TranslatableField/TranslatableField';
import { withTranslation } from 'react-i18next';

import moment from 'moment'
import 'moment/locale/fr';
import momentLocalizer from 'react-widgets-moment';
import 'react-widgets/dist/css/react-widgets.css'

moment.locale('fr');
momentLocalizer();

class SectionForm extends Component<{}> {
    render() {
        const { isLoading }                             = this.props.sections;
        const { handleSubmit, pristine, submitting, t } = this.props;
        return (
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col sm={12} lg={6}>
                            <Card>
                                <CardBody>
                                    <CardTitle><i className="fa fa-info-circle"></i>&nbsp;{t("sections.informations")}</CardTitle>
                                    <CardText tag="div">
                                        <FormGroup row>
                                            <Label for="name" sm={3}>{t("sections.name")}</Label>
                                            <Col sm={9}>
                                                <TranslatableField name="name" placeholder={t("sections.name_placeholder")} component="input"/>
                                            </Col>
                                        </FormGroup>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col className="text-center">
                            <br/>
                            <Button type="submit" color="success" disabled={pristine || submitting || isLoading}>
                                {isLoading ?
                                    <span>
                                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                    </span>
                                    :
                                    <span>
                                        <i className="fa fa-save"></i>&nbsp;
                                        {t("common.save")}
                                    </span>
                                }
                            </Button>
                        </Col>
                    </Row>
                </Form>
        );
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
SectionForm = reduxForm({
  form: 'sectionForm' // a unique identifier for this form
})(SectionForm)

// You have to connect() to any reducers that you wish to connect to yourself
SectionForm = connect(
  state => ({
    initialValues: state.sections.section, // pull initial values from sections reducer
    sections: state.sections,
})
)(SectionForm)

export default withTranslation('translations')(SectionForm)
